import React from 'react';
import { useTranslation } from 'react-i18next';
import { SimpleBarChart } from '@carbon/charts-react';
import { useInventoryCategories } from 'src/hooks/useInventoryCategories';
import { useChartTheme } from './useChartTheme';

interface UsageWasteCategoriesProps {
  title: string;
  usageWasteByCategory: Array<{ categoryId: string; movementType: number; quantity: number }>;
}

const UsageWasteCategories = React.memo((props: UsageWasteCategoriesProps) => {
  const { t } = useTranslation('dashboard');
  const chartTheme = useChartTheme();
  const { isLoading, data: inventoryCategories } = useInventoryCategories();
  const transformedInventoryCategories =
    inventoryCategories?.data?.reduce((previousObject, currentObject) => {
      return Object.assign(previousObject, {
        [currentObject.id]: currentObject.name,
      });
    }, {}) || {};

  return (
    <div className="dashboard__stat_widget">
      <SimpleBarChart
        data={
          isLoading || Object.keys(transformedInventoryCategories).length === 0
            ? []
            : props.usageWasteByCategory?.map((item) => {
                return {
                  group: transformedInventoryCategories[item.categoryId] || item.categoryId,
                  value: item.quantity ?? 0,
                };
              })
        }
        options={{
          title: props.title,
          axes: {
            left: {
              title: t('quantity'),
              mapsTo: 'value',
            },
            bottom: {
              title: t('category'),
              mapsTo: 'group',
              scaleType: 'labels' as any,
            },
          },
          height: '400px',
          theme: chartTheme,
        }}
      />
    </div>
  );
});

export default UsageWasteCategories;
